// extracted by mini-css-extract-plugin
export var carrierIcon = "_uj-0";
export var carrierLogo = "_uj-1";
export var detailsSection = "_uj-2";